/**
 * Secure Email Service
 * Calls CloudFlare Worker API to send emails - no credentials in client!
 */

export interface EmailParams {
  to: string;
  subject: string;
  body: string;
  businessName?: string;
  uploadLink?: string;
}

export const sendEmail = async (params: EmailParams): Promise<{ success: boolean; messageId?: string; error?: string }> => {
  // Determine API endpoint based on environment
  const apiUrl = import.meta.env.PROD
    ? 'https://happyhumantools-email-api.b-9f2.workers.dev' // Production Worker
    : 'http://localhost:8787'; // Local Worker dev

  try {
    const response = await fetch(apiUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(params),
    });

    const result = await response.json();

    if (!response.ok) {
      return {
        success: false,
        error: result.error || 'Failed to send email',
      };
    }

    console.log('Email sent successfully:', result.messageId);
    return {
      success: true,
      messageId: result.messageId,
    };
  } catch (error: any) {
    console.error('Failed to send email:', error);
    return {
      success: false,
      error: error.message || 'Network error - could not reach email service',
    };
  }
};

// Test function to verify the email API is working
export const testSESConnection = async (): Promise<boolean> => {
  try {
    const result = await sendEmail({
      to: 'b@biig.dev', // Test to self
      subject: 'Test Email from HappyHumanTools',
      body: 'This is a test email to verify the email API is configured correctly.',
    });

    return result.success;
  } catch (error) {
    console.error('Email API test failed:', error);
    return false;
  }
};